export const styles = {
  dialogPaper: {
    borderRadius: 1,
    gap: '16px'
  },
  dialogTitle: {
    padding: '24px 24px 16px 24px',
    borderBottom: 'none'
  },
  titleText: {
    fontFamily: 'Inter',
    fontSize: '22px',
    fontWeight: 600,
    lineHeight: '24px',
    color: '#29333d',
    textAlign: 'left'
  },
  closeButton: {
    position: 'absolute',
    right: 22,
    top: 18
  },
  dialogContent: {
    pt: 0
  },
  sectionContainer: {
    mb: 1
  },
  sectionTitle: {
    fontFamily: 'Inter',
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '24px',
    color: '#29333d',
    textAlign: 'left'
  },
  findAddressButton: {
    borderColor: '#E8ECF0',
    backgroundColor: '#FFFFFF',
    color: '#29333D',
    borderRadius: '8px',
    padding: '12px 16px',
    fontSize: '16px',
    fontWeight: 400,
    fontFamily: 'Inter, system-ui, sans-serif',
    textTransform: 'none' as const,
    marginBottom: '16px',
    '&:hover': {
      color: '#29333D'
    }
  },
  inputContainer: {
    mb: 3
  },

  phoneContainer: {
    mb: 1,
    '& > *': {
      '& > *': {
        backgroundColor: '#FFFFFF !important',
        border: '1px solid rgba(0, 0, 0, 0.23) !important',
        borderRadius: '8px !important',
        '&:hover': {
          backgroundColor: '#FFFFFF !important',
          borderColor: 'rgba(0, 0, 0, 0.87) !important'
        },
        '&:focus-within': {
          backgroundColor: '#FFFFFF !important',
          borderColor: 'rgb(59 130 246 / 0.5) !important',
          borderWidth: '2px !important'
        }
      }
    }
  },
  submitButton: {
    backgroundColor: '#016ad4',
    color: '#ffffff',
    borderRadius: '8px',
    padding: '12px 16px',
    marginTop: '70px',
    fontSize: '16px',
    fontWeight: 500,
    fontFamily: 'Inter, system-ui, sans-serif',
    textTransform: 'none' as const,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#0056b3',
      boxShadow: 'none'
    },
    '&:disabled': {
      backgroundColor: '#e0e0e0',
      color: '#9e9e9e'
    }
  },
  mapDialogTitle: {
    paddingBottom: 0
  },
  mapSubtitle: {
    px: 3,
    pb: 2
  },
  mapContainer: {
    position: 'relative',
    height: '100%'
  },
  searchContainer: {
    position: 'absolute',
    top: 16,
    left: 16,
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 1
  },
  searchField: {
    width: '350px',
    backgroundColor: 'transparent'
  },
  searchFieldTransparent: {
    backgroundColor: 'transparent'
  },
  clearButton: {
    padding: '4px',
    borderRadius: 0,
    borderWidth: 0,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      boxShadow: 'none'
    }
  },
  suggestionsContainer: {
    width: '350px',
    backgroundColor: 'white',
    borderRadius: 1,
    gap: 2,
    boxShadow: 2,
    px: 2,
    py: 2
  },
  suggestionsLoadingContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  suggestionsList: {
    width: '100%',
    maxHeight: '40vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(0,0,0,0.05)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,0.2)',
      borderRadius: '4px'
    }
  },
  suggestionItem: {
    padding: 0,
    width: '100%'
  },
  suggestionButton: {
    backgroundColor: '#ffffff',
    padding: '12px 0px',

    minHeight: 'auto',
    width: '100%',
    '&:hover': {
      backgroundColor: '#f2f8fd'
    },
    '&.Mui-selected': {
      backgroundColor: '#e3f2fd',
      '&:hover': {
        backgroundColor: '#bbdefb'
      }
    }
  },
  suggestionText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#29333d',
    textAlign: 'left'
  },
  suggestionTextContainer: {
    margin: 0,
    flex: 1
  },
  confirmButton: {
    textTransform: 'none' as const,
    backgroundColor: '#016AD4',
    color: '#FFFFFF'
  },
  mapMarkerContainer: {
    position: 'relative',
    transform: 'translate(-50%, -100%)',
    cursor: 'pointer'
  },
  mapMarkerPin: {
    width: 40,
    height: 40,
    backgroundColor: '#29333D',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
    position: 'relative',
    zIndex: 2,
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '100%',
      left: '50%',
      transform: 'translateX(-50%) translateY(-5px)',
      width: 0,
      height: 0,
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      borderTop: '12px solid #29333D',
      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
    }
  },
  mapMarkerIcon: {
    fontSize: 20,
    color: 'white'
  },
  mapCard: {
    mb: 2
  },
  mapCardContent: {
    p: 0,
    '&:last-child': {
      pb: 0
    }
  },
  mapAddressContainer: {
    display: 'flex',
    alignItems: 'center',
    mb: 1
  },
  mapAddressText: {
    flexGrow: 1
  },
  mapEditButton: {
    textTransform: 'none' as const,
    minWidth: 'auto',
    p: 0.5,
    ml: 1
  },
  mapEditIcon: {
    fontSize: 16
  },
  googleMapContainer: {
    height: 200,
    borderRadius: 1,
    mb: 2,
    overflow: 'hidden',
    '& > div': {
      borderRadius: 1
    }
  },
  emptyStateContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 3,
    textAlign: 'center',
    backgroundColor: '#ffffff',
    borderRadius: 2,
    minHeight: 200
  },
  emptyStateIconContainer: {
    marginBottom: 2
  },
  emptyStateTitle: {
    color: '#29333D',
    fontWeight: 600,
    marginBottom: 1,
    fontSize: '18px'
  },
  emptyStateDescription: {
    color: '#6B7280',
    fontSize: '14px',
    lineHeight: 1.5,
    maxWidth: '280px'
  },
  locationButton: {
    background: 'white',
    border: '1px solid #ccc',
    borderRadius: '4px',
    cursor: 'pointer',
    width: '40px',
    height: '40px',
    margin: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  locationButtonHover: {
    backgroundColor: '#f8f9fa'
  },
  suggestionsListTile: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },

  clearSelectionButton: {
    minWidth: 24,
    width: 24,
    height: 24,
    padding: 0,
    color: 'inherit',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    }
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left'
  },
  errorMessage: {
    color: '#29333D',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    fontFeatureSettings: "'liga' off, 'clig' off",
    mb: 2,
    maxWidth: '400px',
    textAlign: 'left',
    whiteSpace: 'pre-line'
  },
  errorButton: {
    color: '#666',
    borderColor: '#ddd',
    '&:hover': {
      color: '#333',
      borderColor: '#999',
      backgroundColor: '#f5f5f5'
    }
  },

  // JobSiteCreationLoading styles
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    py: 4,
    px: 2
  },
  illustrationContainer: {
    mb: 4
  },
  illustration: {
    width: '240px',
    height: 'auto',
    maxWidth: '100%'
  },
  messageContainer: {
    mb: 2,
    position: 'relative',
    overflow: 'hidden',
    width: '100%'
  },
  messageTypography: {
    fontWeight: 600,
    color: '#2D3748',
    fontSize: '1.5rem',
    lineHeight: 1.33,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width: '100%',
    minHeight: '32px'
  },
  messagesAnimationContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  descriptionText: {
    color: '#718096',
    mb: 4,
    maxWidth: '400px',
    lineHeight: 1.5,
    whiteSpace: 'pre-line'
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    width: '100%',
    maxWidth: '400px'
  },
  continueButton: {
    backgroundColor: '#1976d2',
    '&:hover': {
      backgroundColor: '#1565c0'
    }
  },
  backButton: {
    color: '#666',
    borderColor: '#ddd',
    '&:hover': {
      color: '#333',
      borderColor: '#999',
      backgroundColor: '#f5f5f5'
    }
  },
  backButtonFullWidth: {
    color: '#666',
    borderColor: '#ddd',
    maxWidth: '400px',
    '&:hover': {
      color: '#333',
      borderColor: '#999',
      backgroundColor: '#f5f5f5'
    }
  },
  loadingSpinner: {
    color: '#3182CE'
  }
}
